import { LDProvider } from "launchdarkly-react-client-sdk";
import { PrimeReactProvider } from "primereact/api";
import React from "react";
import { createRoot } from "react-dom/client";
import {
  DDErrorBoundary,
  initDatadog,
  initDatadogLogs,
  getDatadogVersion,
} from "sj-ui-toolkit/src/integrations";
import { ThemeProvider } from "sj-ui-toolkit/src/theme/ThemeProvider.js";
import { ToastProvider } from "sj-ui-toolkit/src/hooks";
import App from "./App.jsx";

import "sj-ui-toolkit/src/atlas/styles/index.scss";

// Import tailwind via styles.css
import "./styles.css";

// Import theme utilities
import "sj-ui-toolkit/src/atlas/utils/themeUtilities.css";

const version = getDatadogVersion();

// Log app info on startup
console.log(`🚀 user${version ? `: v${version}` : " (no version)"}`);

// ⚠️ WARNING: These credentials are UNIQUE to user-frontend!
// DO NOT copy these to other apps. Each app MUST have its own RUM application.
// To add RUM to a new app: Create new RUM app in Datadog UI, get unique credentials.
// See: .github/instructions/frontend-rum-standards.instructions.md

// Initialize RUM
initDatadog({
  applicationId: "6f587a68-4885-4369-9e6b-4928c0581faa", // ⚠️ UNIQUE to user
  clientToken: "puba10af59d8a86f8040e11534d4e5c9d9b", // ⚠️ UNIQUE to user
  service: "user-frontend",
  version, // Dev: Git SHA, Prod: Semantic version
});

// Initialize Browser Logs (uses same client token as RUM)
initDatadogLogs({
  clientToken: "puba10af59d8a86f8040e11534d4e5c9d9b", // ⚠️ Same as RUM
  service: "user-frontend",
  version,
  forwardErrorsToLogs: true,
  forwardConsoleLogs: ["error"],
});

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <PrimeReactProvider>
      <ThemeProvider loaderOptions={{ loaderOn: true, hideLoaderText: false }}>
        <LDProvider
          clientSideID={import.meta.env.VITE_APP_LAUNCHDARKLY_ID || "638e4dc08684e4120d9a92ef"}
        >
          <ToastProvider>
            <DDErrorBoundary>
              <App />
            </DDErrorBoundary>
          </ToastProvider>
        </LDProvider>
      </ThemeProvider>
    </PrimeReactProvider>
  </React.StrictMode>
);
